import React from 'react';

import type { ExtensionComponentProps } from '@atlaskit/editor-common/extensions/extension-manifest';
import type { EditorContentMode } from '@atlaskit/editor-common/types/editor-appearance';

import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { ErrorBoundary } from '@confluence/error-boundary/entry-points/ErrorBoundary.ts';
import { usePageContentId } from '@confluence/page-context';

import { NBMRendererClient } from './NBMRenderer.tsx';
import type { LegacyContentMacroParams } from './LegacyContentMacroParams.ts';

export type LegacyContentExtensionHandlerProps =
	ExtensionComponentProps<LegacyContentMacroParams> & {
		contentMode?: EditorContentMode;
	};

export const LegacyContentExtensionHandler = (
	props: LegacyContentExtensionHandlerProps,
): React.JSX.Element => {
	const [contentId] = usePageContentId();

	return (
		<ErrorBoundary
			attribution={Attribution.CC_EDITOR_AI}
			attributes={{ contentId, nodeLocalId: props.node?.localId }}
		>
			<NBMRendererClient contentMode={props.contentMode} node={props.node} />
		</ErrorBoundary>
	);
};
